export default __webpack_public_path__ + "static/media/granville19.58025d95.jpg";